__turbopack_context__.v({
  "slider": "wxOZda_slider",
  "wrapper": "wxOZda_wrapper",
});
